module.exports = __webpack_public_path__ + "img/ico-dementia-90-x-90.86559bf6.svg";